module.exports = __webpack_public_path__ + "img/banner1_2.deba7df.png";